<div class="title">Select Date Range</div>
<ngx-daterangepicker-material
	class="date-range-picker"
	[locale]="localConfig"
	[startDate]="selected?.startDate"
	[endDate]="selected?.endDate"
	placeholder="Choose date range"
	[isInvalidDate]="isInvalidDate"
	(datesUpdated)="applyDate($event)"
	[showDropdowns]="true"
	[maxDate]="maxDate"
	[startDateMsg]="startDateMsg"
	[endDateMsg]="endDateMsg"
>
</ngx-daterangepicker-material>
